module.exports = __webpack_public_path__ + "static/AFA_IRS_501c3_Approval-1ac535eb0d4e441fecf4228b88ce4fd1.pdf";